
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const FeaturedSuccess = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="py-24 bg-primary-beige">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/70f4709b506fa7823cb8f6c9d9a99eb3.jpg"
                alt="Client Success Story"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-sage/40 to-transparent"></div>
            </div>
          </motion.div>

          {/* Right: Content Card */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white rounded-3xl p-10 shadow-2xl"
          >
            <div className="inline-flex items-center space-x-2 bg-primary-gold/10 px-4 py-2 rounded-full mb-6">
              <i className="ri-trophy-line text-primary-gold"></i>
              <span className="text-sm font-semibold text-primary-gold">Success Story</span>
            </div>

            <h3 className="font-serif font-bold text-3xl text-primary-charcoal mb-2">
              Chioma Eze
            </h3>
            <p className="text-gray-600 mb-6">E-commerce Business Owner</p>

            <blockquote className="relative mb-8">
              <i className="ri-double-quotes-l text-5xl text-primary-gold/20 absolute -top-4 -left-2"></i>
              <p className="text-lg italic text-gray-700 leading-relaxed relative z-10 pl-8">
                "Working with Titilayo transformed my online store completely. Her strategic guidance and hands-on e-commerce expertise helped me triple my revenue in just 6 months. She didn't just give advice – she walked me through every step, from optimizing my product listings to implementing effective marketing strategies. I couldn't have achieved this level of success without her."
              </p>
            </blockquote>

            <div className="grid grid-cols-3 gap-6 mb-8 p-6 bg-primary-beige rounded-2xl">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary-gold mb-1">300%</div>
                <div className="text-sm text-gray-600">Revenue Growth</div>
              </div>
              <div className="text-center border-l border-r border-gray-300">
                <div className="text-3xl font-bold text-primary-gold mb-1">6</div>
                <div className="text-sm text-gray-600">Months</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary-gold mb-1">5★</div>
                <div className="text-sm text-gray-600">Rating</div>
              </div>
            </div>

            <Link
              to="/success-stories"
              className="inline-flex items-center justify-center w-full px-8 py-4 bg-transparent border-2 border-primary-charcoal text-primary-charcoal hover:bg-primary-charcoal hover:text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Read More Stories
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSuccess;
